import axios from 'axios'
const instance = axios.create({
  baseURL: 'https://www.7788mb.cn:7788',
  timeout: 5000
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  

  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
 
  return response.data
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default instance
